import PrivacyPolicy from "./components";
export default PrivacyPolicy;
